import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWebcamSymbol = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_1422_6070)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M8.54406 12.6741C11.1831 12.6741 13.3225 10.5347 13.3225 7.89562C13.3225 5.25657 11.1831 3.11719 8.54406 3.11719C5.905 3.11719 3.76562 5.25657 3.76562 7.89562C3.76562 10.5347 5.905 12.6741 8.54406 12.6741Z",
				stroke: "#177400",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.54367 10.017C9.71659 10.017 10.6674 9.0662 10.6674 7.89328C10.6674 6.72037 9.71659 5.76953 8.54367 5.76953C7.37076 5.76953 6.41992 6.72037 6.41992 7.89328C6.41992 9.0662 7.37076 10.017 8.54367 10.017Z",
				stroke: "#177400",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.54395 12.6719V14.7956",
				stroke: "#177400",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2.17236 14.7969H14.9149",
				stroke: "#177400",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1422_6070",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16.99,
			height: 16.99,
			fill: "white",
			transform: "translate(0.0488281 0.992188)"
		})
	}) })]
});
export default SvgWebcamSymbol;
